module.exports = __webpack_public_path__ + "img/error_1.82469c97.svg";